import ENV from "./ENV";

// interface IAPIConfig {
//     [k: string]: {
//         URL: string | Function | any;
//         METHOD: "get" | "post" | "delete" | "put" | "patch";
//     };
// }

const APIConfig = {
    // authentication start
    LOGIN: {
        // URL: ENV.API_URL + "/master/auth/login",
        URL: ENV.API_URL + "/auth/login",
        METHOD: "post",
    },
    LOGOUT: {
        // URL: ENV.API_URL + "/master/auth/logout",
        URL: ENV.API_URL + "/auth/logout",
        METHOD: "post",
    },
    CREATE_USER: {
        // URL: ENV.API_URL + "/master/auth/sign-up",
        URL: ENV.API_URL + "/auth/sign-up",
        METHOD: "post",
    },
    GOOGLE_SIGN_IN: {
        // URL: ENV.API_URL + "/master/auth/google-signin",
        URL: ENV.API_URL + "/auth/google-signin",
        METHOD: "post",
    },
    CHECK_LOGIN: {
        URL: ENV.API_URL + "/auth/check-login",
        METHOD: "get",
    },
    SEND_OTP: {
        // URL: ENV.API_URL + "/master/auth/send-otp",
        URL: ENV.API_URL + "/auth/send-otp",
        METHOD: "post",
    },
    VERIFY_OTP: {
        // URL: ENV.API_URL + "/auth/verify-otp",
        URL: ENV.API_URL + "/auth/verify-otp",
        METHOD: "post",
    },
    SEND_RESET_PASSWORD_EMAIL: {
        URL: ENV.API_URL + "/auth/forgot-password",
        // URL: ENV.API_URL + "/master/auth/forgot-password",
        METHOD: "post",
    },
    RESET_PASSWORD: {
        // URL: ENV.API_URL + "/auth/verify-forgot-password",
        URL: ENV.API_URL + "/auth/verify-forgot-password",
        METHOD: "post",
    },
    GOOGLE_LOGIN: {
        URL: ENV.API_URL + "/auth/google-sign-in",
        // URL: ENV.API_URL + "/master/auth/google-signin",
        METHOD: "post",
    },
    GENERATE_CODE_FROM_PROMPT: {
        URL: ENV.API_URL + "/code/generate-code",
        METHOD: "post",
    },

    GENERATE_URL_FROM_PROMPT: {
        URL: ENV.API_URL + "/code/generate-url",
        METHOD: "post",
    },

    GENERATE_HERUKO_URL: {
        URL: ENV.API_URL + "/code/generate_heruko_url",
        METHOD: "post",
    },

    //Project apis

    GET_USER_PROJECTS: {
        // URL: ENV.API_URL + "/master/project/?status=&page=1&page_size=100",
        URL: ENV.API_URL + "/project/?status=&page=1&page_size=20",
        METHOD: "get",
    },

    GET_PROJECT_ASSETS: {
        URL: (projectId: string) => ENV.API_URL + "/project/" + projectId + "/assets",
        METHOD: "get",
    },

    CREATE_PROJECT: {
        // URL: ENV.API_URL + "/master/project/",
        URL: ENV.API_URL + "/project/",
        METHOD: "post",
    },

    GET_CHAT_HISTORY: {
        // URL: (projectId: string) => ENV.API_URL + "/master/project/" + projectId + "/chat",
        URL: (projectId: string) => ENV.API_URL + "/project/" + projectId + "/chat",
        METHOD: "get",
    },

    GET_PROJECT_AUTO_COMPLETE: {
        URL: (projectId: string) => ENV.API_URL + "/project/" + projectId + "/auto-complete",
        METHOD: "post",
    },

    // GET_PREVIOUS_CODE: {
    //     // URL: ENV.API_URL + "/master/code/fetch-code",
    //     URL:(projectId: string) =>  ENV.API_URL + "/code/"+ projectId +"/code",
    //     METHOD: "get",
    // },

    UPDATE_CODE: {
        // URL: ENV.API_URL + "/master/project/session",
        URL: (projectId: string) => ENV.API_URL + "/project/" + projectId + "/create-session",
        METHOD: "post",
    },

    REQUIREMENT_GATHERING: {
        URL: ENV.API_URL + "/agents/continue",
        METHOD: "post",
    },
    GENERATE_APP_PROMPT_FROM_SUMMARY: {
        URL: ENV.API_URL + "/agents/generate-app-prompt",
        METHOD: "post",
    },
    CONTINUE_GATHERING: {
        URL: ENV.API_URL + "/agents/continue",
        METHOD: "post",
    },

    FIX_ERROR: {
        URL: ENV.API_URL + "/agents/fix-error",
        METHOD: "post",
    },

    UPLOAD_CSV_FILE: {
        URL: ENV.API_URL + "/databases/upload-csv",
        METHOD: "post",
    },

    UPLOAD_EXCEL_FILE: {
        URL: ENV.API_URL + "/databases/upload-excel",
        METHOD: "post",
    },

    ADD_DATABASE: {
        URL: ENV.API_URL + "/connect-postgres",
        METHOD: "post",
    },

    PROJECT_SESSIONS: {
        URL: (projectId: string) => ENV.API_URL + "/project/" + projectId + "/sessions",
        METHOD: "get",
    },
    GET_COMMIT_DATA: {
        URL: ENV.API_URL + "/code/fetch-commit",
        METHOD: "post",
    },
    REVERT_TO_A_SESSION: {
        URL: (projectId: string) => ENV.API_URL + "/project/" + projectId + "/set-active-session",
        METHOD: "post",
    },
    REVIEW_SERVICE: {
        URL: ENV.API_URL + "/feedback",
        METHOD: "post",
    },
    EDIT_DOCS: {
        URL: ENV.API_URL + "/databases/edit-docs",
        METHOD: "post",
    },
    GET_PUBLIC_APPS: {
        URL: ENV.API_URL + "/project/all-projects",
        METHOD: "post",
    },
    GET_EXPLORE_PROJECTS: {
        URL: ENV.API_URL + "/project/explore-projects",
        METHOD: "post",
    },
    GET_SUBSCRIPTION_PLANS: {
        URL: ENV.API_URL + "/payment/plans",
        METHOD: "get",
    },
    GET_TOPUP_PLANS: {
        URL: ENV.API_URL + "/payment/top-up-plans",
        METHOD: "get",
    },
    CREATE_TOPUP_TRANSACTION: {
        URL: ENV.API_URL + "/payment/top-up/transaction",
        METHOD: "post",
    },
    SUBSCRIBE: {
        URL: ENV.API_URL + "/payments/subscribe",
        METHOD: "post",
    },
    VERIFY_SUBDOMAIN: {
        URL: ENV.API_URL + "/project/verify-subdomain",
        METHOD: "post",
    },
    DEPLOY_APP: {
        URL: (projectId: string) => ENV.API_URL + "/deploy/" + projectId,
        METHOD: "post",
    },
    GENERATE_PREVIEW: {
        // URL: (projectId: string) => ENV.API_URL + "/master/project/" + projectId + "/preview",
        URL: (projectId: string) => ENV.API_URL + "/project/" + projectId + "/preview",
        METHOD: "get",
    },
    GET_PROJECT_DETAILS: {
        // URL: (projectId: string) => ENV.API_URL + "/master/project/" + projectId,
        URL: (projectId: string) => ENV.API_URL + "/project/" + projectId,
        METHOD: "get",
    },
    GET_PROJECT_CODE: {
        URL: (projectId: string) => ENV.API_URL + "/project/" + projectId + "/code",
        METHOD: "get",
    },
    STORE_PROJECT_API_KEYS: {
        URL: (projectId: string) => ENV.API_URL + "/project/" + projectId + "/api-keys",
        METHOD: "post",
    },
    GET_PROJECT_API_KEYS: {
        URL: (projectId: string) => ENV.API_URL + "/project/" + projectId + "/api-keys",
        METHOD: "get",
    },
    ADD_USER_SUBSCRIPTION: {
        URL: ENV.API_URL + "/payments/add-user-subscription",
        METHOD: "post",
    },
    GET_TOKEN_UTILIZATION: {
        URL: ENV.API_URL + "/payment/token-balance",
        METHOD: "get"
    },
    UPLOAD_ASSET: {
        URL: ENV.API_URL + "/databases/upload-asset",
        METHOD: "post",
    },
    FETCH_PROJECT_ASSETS: {
        URL: (projectId: string) => ENV.API_URL + "/databases/assets/" + projectId,
        METHOD: "get"
    },
    FORK_APP: {
        URL: ENV.API_URL + "/project/fork-project",
        METHOD: "post"
    },

    SAVE_ROLE_SELECTION: {
        URL: ENV.API_URL + "/auth/on-boarding",
        METHOD: "post",
    },
    GET_REQUIREMENT_CHAT_HISTORY: {
        URL: (projectId: string) => ENV.API_URL + "/chat/requirement-chat-history/" + projectId,
        METHOD: "get",
    },
    GET_SHARED_PROJECT_CODE: {
        URL: (projectId: string) => ENV.API_URL + '/project/unauth/' + projectId,
        METHOD: "get"
    },
    GET_SUPABASE_LOGIN_URL: {
        URL: ENV.API_URL + '/connect-supabase/login',
        METHOD: "get"
    },
    CONNECT_SUPABASE_AUTH: {
        URL: (params: string) => ENV.API_URL + '/supabase/oauth2/callback' + params,
        METHOD: "get"
    },
    GET_SUPABASE_PROJECTS: {
        URL: ENV.API_URL + '/supabase/projects',
        METHOD: "get"
    },
    SUPABASE_LOGIN: {
        URL: ENV.API_URL + '/supabase/init-login',
        METHOD: "get"
    },
    CONNECT_SUPABASE_PROJECT: {
        URL: (projectId: string) => ENV.API_URL + '/supabase/' + projectId + '/connect',
        METHOD: "post"
    },
    DISCONNECT_SUPABASE_PROJECT: {
        URL: (projectId: string) => ENV.API_URL + '/supabase/' + projectId + '/disconnect',
        METHOD: "post"
    },
    APPLY_DATABASE_CHANGES: {
        URL: (migrationId: string) => ENV.API_URL + '/supabase/migrations/' + migrationId + '/execute',
        METHOD: "post"
    },
    CREATE_SUPABASE_PROJECT: {
        URL: ENV.API_URL + '/supabase/project',
        METHOD: "post"
    },
    AGENT_START: {
        URL: (projectId: string) => ENV.API_URL + '/project/' + projectId + '/start-session',
        METHOD: "post"
    },
    CONVERT_APP: {
        URL: ENV.API_URL + '/project/convert-app',
        METHOD: "post"
    },

    SAVE_LOGS: {
        URL: ENV.VITE_API_URL_LOGS + '/logs',
        METHOD: "post"
    },
    UPDATE_PROJECT: {
        URL: (projectId: string) => ENV.API_URL + '/project/' + projectId,
        METHOD: "put"
    },
    CREATE_PROJECT_ASSET_URL: {
        URL: (projectId: string) => ENV.API_URL + '/project/' + projectId + "/assets",
        METHOD: "post"
    },
    UPLOAD_ASSET_TO_URL: {
        URL: (assetUrl: string) => assetUrl,
        METHOD: "put"
    },
    DELETE_PROJECT_ASSET: {
        URL: (projectId: string, assetName: string) => ENV.API_URL + '/project/' + projectId + '/assets/' + assetName,
        METHOD: "delete"
    },
    GET_ALL_USERS: {
        URL: ENV.VITE_ADMIN_API + "/auth/user",
        METHOD: "post",
    },
    ADD_ADMIN_SUBSCRIPTION: {
        URL: ENV.VITE_ADMIN_API + "/payment/add-subscription",
        METHOD: "post",
    },
    GET_ALL_PROJECTS: {
        URL: ENV.VITE_ADMIN_API + "/project/all-projects",
        METHOD: "post",
    },
    GET_USER_TOKEN_BY_ID: {
        URL: ENV.VITE_ADMIN_API + `/auth/login`,
        METHOD: "post",
    },
    ADD_TOKEN_CREDITS: {
        URL: ENV.VITE_ADMIN_API + "/payment/add-token-credits",
        METHOD: "post",
    },
    CREATE_TRANSACTION: {
        URL: ENV.API_URL + "/payment/transaction",
        METHOD: "post",
    },
    CHECK_TRANSACTION: {
        URL: (transactionId: string) => ENV.API_URL + "/payment/transaction/" + transactionId,
        METHOD: "get",
    },
    GET_SUBSCRIPTIONS: {
        URL: ENV.API_URL + "/payment/subscription",
        METHOD: "get",
    },
    CANCEL_SUBSCRIPTION: {
        URL: (subscriptionId: string) => ENV.API_URL + `/payment/subscription/${subscriptionId}/cancel`,
        METHOD: "post",
    },
    GET_FLY_LOG_ERRORS: {
        URL: (projectId: string) => ENV.VITE_API_PREVIEW_LOGS_URL + "/logs/" + projectId + "/error",
        METHOD: "get",
    },
    PAUSE_SUPABASE_PROJECT: {
        URL: (projectId: string) => ENV.API_URL + '/supabase/' + projectId + '/pause',
        METHOD: "post"
    },
    RESTORE_SUPABASE_PROJECT: {
        URL: (projectId: string) => ENV.API_URL + '/supabase/' + projectId + '/restore',
        METHOD: "post"
    },
    PM_AGENT_START: {
        URL: (projectId: string) => ENV.API_URL + '/project/' + projectId + '/start-project-manager-session',
        METHOD: "post"
    },
    GENERATE_PROMPT_FROM_PM_CONVERSATION: {
        URL: (projectId: string) => ENV.API_URL + '/project/' + projectId + '/magic-prompt',
        METHOD: "post"
    },
    CREATE_PM_SESSION: {
        URL: (projectId: string) => ENV.API_URL + '/project/' + projectId + '/create-project-manager-session',
        METHOD: "post"
    },
    GET_PM_CONVERSATION: {
        URL: (projectId: string) => ENV.API_URL + '/project/' + projectId + '/project-manager-conversation',
        METHOD: "get"
    },
    CREATE_FLY_CERTIFICATE: {
        URL: (projectId: string) => ENV.API_URL + '/deploy/' + projectId + '/fly-certificate',
        METHOD: "post"
    },
    GET_FLY_CERTIFICATES: {
        URL: (projectId: string) => ENV.API_URL + '/deploy/' + projectId + '/fly-certificate',
        METHOD: "get"
    }
};

export default APIConfig;
